import MainChaptersList from './MainChaptersList';
import { Link } from 'react-router-dom';

export default function MainChapters(props) {
	return (
    <main className="container mx-auto my-4 px-4 lg:px-16 xl:px-32">
      <div className="px-4 my-8 text-3xl font-semibold scroll-mt-16" ref={props.location}>Her Adventures</div>
      <div className="flex my-2 py-4 px-4 border border-neutral-900 dark:border-neutral-100 rounded-lg">
        <div className="flex flex-col">
          <h3 className="text-neutral-600 dark:text-neutral-400">Chapter I</h3>
          <h4 className="text-2xl">Down the Rabbit-hole</h4>
          <p className="text-justify">
            Alice was beginning to get very tired of sitting by her sister on the bank, and
            of having nothing to do: once or twice she had peeped into the book her sister
            was reading, but it had no pictures or conversations in it...
          </p>
          <button className="mt-2 px-3 py-2 self-end bg-neutral-900 hover:bg-neutral-700 dark:bg-neutral-100 dark:hover:bg-neutral-300 active:ring-4 active:ring-neutral-500 dark:border rounded-lg text-neutral-100 dark:text-neutral-900">
            <Link to="/chapter1">
              Keep Reading
            </Link>
          </button>
        </div>
      </div>
      <MainChaptersList index="Chapter II" name="The Pool of Tears" link="/chapter2"/>
      <MainChaptersList index="Chapter III" name="A Caucus-race and a Long Tale" link="/chapter3"/>
      <MainChaptersList index="Chapter IV" name="The Rabbit sends in a Little Bill" link="/chapter4"/>
      <MainChaptersList index="Chapter V" name="Advice from a Caterpillar" link="/chapter5"/>
      <MainChaptersList index="Chapter VI" name="Pig and Pepper" link="/chapter6"/>
      <MainChaptersList index="Chapter VII" name="A Mad Tea-party" link="/chapter7"/>
      <MainChaptersList index="Chapter VIII" name="The Queen's Croquet-ground" link="/chapter8"/>
      <MainChaptersList index="Chapter IX" name="The Mock Turtle's Story" link="/chapter9"/>
      <MainChaptersList index="Chapter X" name="The Lobster Quadrille" link="/chapter10"/>
      <MainChaptersList index="Chapter XI" name="Who Stole the Tarts?" link="/chapter11"/>
      <MainChaptersList index="Chapter XII" name="Alice's Evidence" link="/chapter12"/>
    </main>
	)
}